import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-obsidian-900/95 backdrop-blur-lg border-t border-white/10 py-4 mt-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-400">
            © {new Date().getFullYear()} Divine Intelligence. All rights reserved.
          </div>
          <nav className="flex gap-6">
            <Link 
              to="/privacy-policy" 
              className="text-sm text-gray-400 hover:text-gold-400 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/eula" 
              className="text-sm text-gray-400 hover:text-gold-400 transition-colors"
            >
              Terms of Service
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
